import { render, staticRenderFns } from "./AppraisalDetail.vue?vue&type=template&id=54fc5838&scoped=true"
import script from "./AppraisalDetail.vue?vue&type=script&lang=js"
export * from "./AppraisalDetail.vue?vue&type=script&lang=js"
import style0 from "./AppraisalDetail.vue?vue&type=style&index=0&id=54fc5838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fc5838",
  null
  
)

export default component.exports